import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 4EDBF232-461F-4F4C-82BB-64A89BA08405
 * name arrow-up-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowUpThickIcon = createSvgIcon(<><path d="M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z" /></>, 'ArrowUpThickIcon');
export default ArrowUpThickIcon